import { authService } from "./auth";
// import { Password } from './passwordChange'
export { authService };
